import { render } from "./RegistOneClassEduPay.vue?vue&type=template&id=65ce4290&scoped=true"
import script from "./RegistOneClassEduPay.vue?vue&type=script&lang=js"
export * from "./RegistOneClassEduPay.vue?vue&type=script&lang=js"

import "./RegistOneClassEduPay.vue?vue&type=style&index=0&id=65ce4290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ce4290"]])

export default __exports__